/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import './App.scss';
import { MessagesSquareIcon, RadioIcon, SkullIcon, StarIcon, TvIcon } from 'lucide-react';

function Countdown() {
  const [days, setDays] = React.useState('00');
  const [hours, setHours] = React.useState('00');
  const [minutes, setMinutes] = React.useState('00');
  const [seconds, setSeconds] = React.useState('00');

  React.useEffect(() => {
    const countDownDate = new Date("Nov 03, 2025 18:00:00").getTime();
    const x = setInterval(() => {
      const now = new Date().getTime();
      const distance = countDownDate - now;
      const d = Math.floor(distance / (1000 * 60 * 60 * 24));
      const h = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const m = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const s = Math.floor((distance % (1000 * 60)) / 1000);
      setDays(d < 10 ? `0${d}` : d);
      setHours(h < 10 ? `0${h}` : h);
      setMinutes(m < 10 ? `0${m}` : m);
      setSeconds(s < 10 ? `0${s}` : s);
      if (distance < 0) {
        clearInterval(x);
        setDays('00');
        setHours('00');
        setMinutes('00');
        setSeconds('00');
      }
    }, 1000);
    return () => clearInterval(x);
  });

  return (
    <div id="countdown">
      <div className='cdBox' id="cdDays">
        <span className="cdValues" id="cdDaysValue">{days}</span>
        <span className='cdText' id="cdDaysText">Dias</span>
      </div>
      <div className='cdBox' id="cdHours">
        <span className="cdValues" id="cdHoursValue">{hours}</span>
        <span className='cdText' id="cdHoursText">Horas</span>
      </div>
      <div className='cdBox' id="cdMinutes">
        <span className="cdValues" id="cdMinutesValue">{minutes}</span>
        <span className='cdText' id="cdMinutesText">Minutos</span>
      </div>
      <div className='cdBox' id="cdSeconds">
        <span className="cdValues" id="cdSecondsValue">{seconds}</span>
        <span className='cdText' id="cdSecondsText">Segundos</span>
      </div>
    </div>
  )
}

function showLogo() {
  const logo = document.getElementById('logo');
  setTimeout(() => {
    logo.style.opacity = '1';
  }, 2050);
}

function showCountdown() {
  const day = document.getElementById('cdDays');
  const hour = document.getElementById('cdHours');
  const minute = document.getElementById('cdMinutes');
  const second = document.getElementById('cdSeconds');
  setTimeout(() => {
    day.style.opacity = '1';
  }, 2500);

  setTimeout(() => {
    hour.style.opacity = '1';
  }, 2750);

  setTimeout(() => {
    minute.style.opacity = '1';
  }, 2900);

  setTimeout(() => {
    second.style.opacity = '1';
  }, 3050);
}

const Background = () => {
  const particles = [];
  for (let i = 0; i < 31; i++) {
    particles.push(
      <div key={i} className="particleContainer">
        <div className="particle" />
      </div>,
    );
  }

  return (
    <>
      <div className="authFadeBottom" />
      <div className="particlesParent">{particles}</div>
    </>
  );
};

function Apresentation() {
  React.useEffect(() => {
    showLogo();
    showCountdown();
  }, []);

  return (
    <>
      <div className='shader' id="blurEffect" />
      <div id="principal">
        <div id="pContent">
          <img src="logoApresentation.png" alt="DaKasa LTDA" id="logo"/>
          <Countdown />
        </div>
      </div>
    </>
  )
}

function DisplayTitle() {
  function RollListDownWords() {
    const words = ['acolhe', 'impulsiona', 'engaja'];
    const [word, setWord] = React.useState('');
    const [index, setIndex] = React.useState(-1);

    async function typping() {
      await animationTyppingWord();
      setTimeout(() => {
        animationEraseWord();
      }, 3000);
    }

    async function animationTyppingWord() {
      const chosenWord = words[index];
      const timeBetweenLetter = 1000 / chosenWord.length;
        for (let i = 0; i < chosenWord.length; i++) {
          setTimeout(() => {
            setWord(chosenWord.slice(0, i + 1));
          }, i * timeBetweenLetter);
        }
      }

    async function animationEraseWord() {
      const chosenWord = words[index];
      const timeBetweenLetter = 1000 / chosenWord.length;
      let n = 0;
      for (let i = chosenWord.length; i >= 0; i--) {
        setTimeout(() => {
          setWord(chosenWord.slice(0, i));
        }, n * timeBetweenLetter);
        n++;
      }
    }

    React.useEffect(() => {
      setIndex(0);
      const interval = setInterval(() => {
        setIndex(prevIndex => (prevIndex + 1) % words.length);
      }, 4500);

      return () => clearInterval(interval);
    }, []);

    React.useEffect(() => {
      if (index === -1) return;
      typping();
    }, [index]);

    if (index === -1) {
      return <></>;
    }

    return (
      <span id="highlighDisplayTitleWord">{word}</span>
    );
  }

  return (
    <div className="displayTitle">
      <h1 id="displayTitleName">DaKasa</h1>
      <h2 id="displayTitleDesc">A rede social que te <RollListDownWords /></h2>
    </div>
  );
}

function HitOrFlop() {
  return (
    <div className="hitOrFlopContainer">
      <div className="hitOrFlopHeader">
        <div className='sessionHeaderContainer hitHeaderContainer'>
          <StarIcon 
          className="hitIconHeader"
          size={30}
          />
          <span>HIT</span>
        </div>
        <span className='versusHitOrFlop'>VS</span>
        <div className='sessionHeaderContainer flopHeaderContainer'>
          <span>FLOP</span>
          <SkullIcon 
          className="flopIconHeader"
          size={30}
          strokeWidth={2}
          />
        </div>
      </div>
      <div className='hitOrFlopCard'>
        <div className='hitOrFlopCardInner'>
          <div className='hitCard'>
            <span className='hitCardTitle'>HIT <StarIcon size={32}/></span>
            <span className='hitCardText'>HITOU! HIT é aquele momento de fama e glória que todo usuário pode alcançar!</span>
          </div>
          <div className='flopCard'>
            <span className='flopCardTitle'>FLOP <SkullIcon size={32}/></span>
            <span className='flopCardText'>Eh... Geralmente o FLOP é algo dificil de lidar... Mas aqui essa crise pode ser uma oportunidade de prosperidade</span>
          </div>
        </div>
      </div>
    </div>
  );
}

function TapeEffect(props) {
  function fillTape({ id, extra = 0.25 }) {
    const line  = document.getElementById(id);
    const box   = document.getElementById(`${id}-container`);
    if (!line || !box) return;
  
    line.textContent = props.block;
    const blockWidth   = line.offsetWidth;
    const targetWidth  = box.offsetWidth * (2 + extra);
    const reps         = Math.ceil(targetWidth / blockWidth);
  
    line.textContent = props.block.repeat(reps);
  }

  React.useEffect(() => {
    fillTape({ id: props.id, extra: 0.3 });
  })

  return (
    <div id={`${props.id}-container`} className="tapeEffectContainer">
      <div className="tapeEffectLine">
        <span id={props.id} className='tapeEffectLineText'></span>
      </div>
    </div>
  );
}

function Rooms() {
  return (
    <div id="roomsContainer">
      <TapeEffect id="tapeEffectLine1" block="MEU QUARTO •  PROIBIDO ENTRAR  •  " />
      <TapeEffect id="tapeEffectLine2" block="MEU QUARTO •  PROIBIDO ENTRAR  •  " />
      <div id="roomsContainerInner">
        <div id="roomsContent">
          <div id="roomsContentTitleContainer">
            <div id="roomsContentTitleContainerInner">
              <h1 id="roomsContentTitle">O Quarto</h1>
            </div>
          </div>
          <span id="roomsContentDesc">Aqui você tem direito e ter um espaço exclusivamente seu, onde os seus amigos, familiares, seguidores, ou qualquer outro tipo de pessoa bem-vinda possa te acompanhar! Para as suas visitas não ficarem entendiadas, disponibilizamos alguns recursos para entretê-los:</span>
          <div id="roomsContentFeatures">
            <div className="roomsContentFeature">
              <MessagesSquareIcon className='roomsContentFeatureIcon' size={62} />
              <span className="roomsContentFeatureTitle">Chat</span>
            </div>
            <div className="roomsContentFeature">
              <TvIcon className='roomsContentFeatureIcon' size={62} />
              <span className="roomsContentFeatureTitle">TV</span>
            </div>
            <div className="roomsContentFeature">
              <RadioIcon className='roomsContentFeatureIcon' size={62} />
              <span className="roomsContentFeatureTitle">Rádio</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function Footer() {
  return (
    <div id="footer">
      <span>DaKasa LTDA</span>
      <span>© 2025</span>
      <span>Todos os direitos reservados</span>
    </div>
  )
}

function App() {
  return (
    <>
    <Background />
    <div className="App">
      <Apresentation />
      <div id="sessionDivider">
        <DisplayTitle />
        <HitOrFlop />
        <Rooms />
        <Footer />
      </div>
    </div>
    </>
  );
}

export default App;
